import React from 'react';

import {
  MjmlSection,
  MjmlColumn,
  MjmlImage,
} from 'lane-shared/emails/MjmlComponentsV2';

export function EmailVisitorHero({
  logoUri,
  backgroundUrl,
  enableAspectRatioFix,
}: {
  logoUri?: string;
  backgroundUrl?: string;
  enableAspectRatioFix?: boolean;
}) {
  const fallbackBackground =
    'https://lane-media-prd-us-east-2.s3.amazonaws.com/visitor-email-hero-fallback.png';

  return enableAspectRatioFix ? (
    <MjmlSection
      padding-top="28.125%"
      padding-bottom="28.125%"
      padding-left="14%"
      padding-right="14%"
      background-color="#F5F6F7"
      background-url={backgroundUrl || fallbackBackground}
      background-size="cover"
      background-repeat="no-repeat"
    >
      {logoUri && (
        <MjmlColumn>
          <MjmlImage width="100px" src={logoUri} />
        </MjmlColumn>
      )}
    </MjmlSection>
  ) : (
    <MjmlSection
      padding="14%"
      background-color="#F5F6F7"
      background-url={backgroundUrl || fallbackBackground}
      background-size="cover"
    >
      {logoUri && (
        <MjmlColumn>
          <MjmlImage width="100px" src={logoUri} />
        </MjmlColumn>
      )}
    </MjmlSection>
  );
}
